export default __webpack_public_path__ + "static/media/pocha32.297208ea.jpeg";